import { render, staticRenderFns } from "./linked-field.vue?vue&type=template&id=5b1060dc&"
import script from "./linked-field.vue?vue&type=script&lang=js&"
export * from "./linked-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1060dc')) {
      api.createRecord('5b1060dc', component.options)
    } else {
      api.reload('5b1060dc', component.options)
    }
    module.hot.accept("./linked-field.vue?vue&type=template&id=5b1060dc&", function () {
      api.rerender('5b1060dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/linked-field.vue"
export default component.exports